import type { CollectiveGroupSportResponse } from '@on3/api';
import { SportIcon } from 'components/Icons/SportIcon';
import { Text } from 'components/UI/Typography/Text';

import styles from './SportTab.module.scss';

export const SportTabItems = ({
  sportKey,
  name,
}: CollectiveGroupSportResponse) => {
  return (
    <div className={styles.sportItem}>
      <SportIcon className={styles.sportIcon} sportName={sportKey ?? 1} />
      <Text className={styles.sportName} key={sportKey} variant="subtitle1">
        {name}
      </Text>
    </div>
  );
};
